/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * htoken API
 * OpenAPI spec version: v1
 */
export const SavePortalOnboardingStep = {
    PERSONAL: 'PERSONAL',
    PEP: 'PEP',
    CUSTODY: 'CUSTODY',
    KYC: 'KYC',
};
//# sourceMappingURL=savePortalOnboardingStep.js.map